/**
 * Imports all api interceptors in this folder
 */
const requireApiInterceptors = require.context('.', true, /\.js$/);
requireApiInterceptors.keys().forEach(fileName => {
  if (fileName !== './index.js') {
    requireApiInterceptors(fileName);
  }
});
